import React from 'react';
import { View } from 'react-native';
import Svg, { G, Rect } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const WeightMedium = ({
  color = colors.primary,
  isInverted = true,
  size = 24,
  style,
  ...props
}: IconProps & { isInverted?: boolean }) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg viewBox="0 0 220 220" width={size} height={size}>
          <g transform="translate(15,115) scale(0.55)">
            <rect
              x="0"
              y="0"
              width="65"
              height="85"
              rx="8"
              ry="8"
              fill={isInverted ? 'white' : color}
              stroke={isInverted ? 'white' : color}
              strokeWidth="20"
            />
            <rect
              x="12"
              y="-22"
              width="42"
              height="22"
              rx="5"
              ry="5"
              fill={isInverted ? 'white' : color}
              stroke={isInverted ? 'white' : color}
              strokeWidth="20"
            />
          </g>
          <g transform="translate(90,105) scale(0.65)">
            <rect
              x="0"
              y="0"
              width="65"
              height="85"
              rx="8"
              ry="8"
              fill={isInverted ? 'white' : color}
              stroke={isInverted ? 'white' : color}
              strokeWidth="20"
            />
            <rect
              x="12"
              y="-22"
              width="42"
              height="22"
              rx="5"
              ry="5"
              fill={isInverted ? 'white' : color}
              stroke={isInverted ? 'white' : color}
              strokeWidth="20"
            />
          </g>
          <g transform="translate(165,95) scale(0.75)">
            <rect
              x="0"
              y="0"
              width="65"
              height="85"
              rx="8"
              ry="8"
              fill="none"
              stroke={isInverted ? 'white' : color}
              strokeWidth="20"
            />
            <rect
              x="12"
              y="-22"
              width="42"
              height="22"
              rx="5"
              ry="5"
              fill="none"
              stroke={isInverted ? 'white' : color}
              strokeWidth="20"
            />
          </g>
        </svg>
      </View>
    );
  }

  return (
    <Svg
      viewBox="0 0 220 220"
      width={size}
      height={size}
      style={style}
      {...props}
    >
      <G transform="translate(15,115) scale(0.55)">
        <Rect
          x="0"
          y="0"
          width="65"
          height="85"
          rx="8"
          ry="8"
          fill={isInverted ? 'white' : color}
          stroke={isInverted ? 'white' : color}
          strokeWidth="20"
        />
        <Rect
          x="12"
          y="-22"
          width="42"
          height="22"
          rx="5"
          ry="5"
          fill={isInverted ? 'white' : color}
          stroke={isInverted ? 'white' : color}
          strokeWidth="20"
        />
      </G>
      <G transform="translate(90,105) scale(0.65)">
        <Rect
          x="0"
          y="0"
          width="65"
          height="85"
          rx="8"
          ry="8"
          fill={isInverted ? 'white' : color}
          stroke={isInverted ? 'white' : color}
          strokeWidth="20"
        />
        <Rect
          x="12"
          y="-22"
          width="42"
          height="22"
          rx="5"
          ry="5"
          fill={isInverted ? 'white' : color}
          stroke={isInverted ? 'white' : color}
          strokeWidth="20"
        />
      </G>
      <G transform="translate(165,95) scale(0.75)">
        <Rect
          x="0"
          y="0"
          width="65"
          height="85"
          rx="8"
          ry="8"
          fill="none"
          stroke={isInverted ? 'white' : color}
          strokeWidth="20"
        />
        <Rect
          x="12"
          y="-22"
          width="42"
          height="22"
          rx="5"
          ry="5"
          fill="none"
          stroke={isInverted ? 'white' : color}
          strokeWidth="20"
        />
      </G>
    </Svg>
  );
};
